import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function fetchPrescriptionTest(numberText, action) {
  const axios = axiosInstance().primoLab;
  let data = [];

  await axios
    .get(`/prescriptions`, {
      params: {
        number_text: numberText,
        action: action,
      }
    })
    .then(async (response) => {
      data = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { data };
}
